import React from 'react';
import ProductsFeature from '../features/products/Products';

const ProductsPage: React.FC = () => {
    return <ProductsFeature />;
};

export default ProductsPage;
